$(document).on("click", ".new_filter_type", function () {
  $(this).siblings().find("input").prop("checked", false);
  var $input = $(this).find("input");
  var vall = "";
  if ($input.is(":checked")) {
    $input.prop("checked", false);
    vall = "";
    $("select#SortBy").val("manual");
  } else {
    $input.prop("checked", true);
    vall = $input.val();
    $("select#SortBy").val(vall);
  }
  console.log(vall);
  $(
    "ul.facets-layout.facets-layout-list li.list-menu__item:eq(0) label"
  ).click();
  $(
    "ul.facets-layout.facets-layout-list li.list-menu__item:eq(0) label"
  ).click();
});

$(document).on("change", ".search_and_sort select", function () {
  var vall = $(this).val();
  $("select#SortBy").val(vall);
  $(
    "ul.facets-layout.facets-layout-list li.list-menu__item:eq(0) label"
  ).click();
  $(
    "ul.facets-layout.facets-layout-list li.list-menu__item:eq(0) label"
  ).click();
});

// $(document).ready(function() {
//     function debounce(func, wait) {
//         let timeout;
//         return function() {
//             const context = this, args = arguments;
//             clearTimeout(timeout);
//             timeout = setTimeout(() => func.apply(context, args), wait);
//         };
//     }

//     function filterProducts() {
//         const value = $('input#search-box').val().toLowerCase();
//         $('div#ProductGridContainer .collection ul#product-grid li').each(function() {
//             $(this).toggle($(this).data('val').toLowerCase().indexOf(value) > -1 || value === '');
//         });
//     }

//     const debouncedFilterProducts = debounce(filterProducts, 300);

//     $(document).on('keyup', 'input#search-box', function(e) {
//         e.preventDefault();
//         e.stopPropagation();
//         debouncedFilterProducts();
//     }).trigger('keyup');
// });

var colll = window.location.href.split("/");
var collectionHandle = colll[colll.length - 1].split("?")[0];
const productsPerPage = 250;
let allProducts = [];
let currentPage = 1;

async function fetchProducts(page) {
  try {
    const response = await fetch(
      `/collections/${collectionHandle}/products.json?limit=${productsPerPage}&page=${page}`
    );
    const data = await response.json();
    if (data.products.length > 0) {
      allProducts = allProducts.concat(data.products);
      return fetchProducts(page + 1);
    } else {
      return allProducts;
    }
  } catch (error) {
    console.log("Error fetching products:", error);
  }
}

$(document).ready(function () {
  //console.log('collectionHandle',!!collectionHandle);
  if(!!collectionHandle){
    fetchProducts(currentPage)
    .then((products) => {
      allProducts = products;
    })
    .catch((error) => console.log("Error:", error));
  }
  

  $(".search_and_sort .search_box input").on("keyup", function () {
    const searchString = $(this).val().toLowerCase();

    if (searchString) {
      const matchedProducts = allProducts.filter((product) =>
        product.title.toLowerCase().includes(searchString)
      );
      displayProducts(matchedProducts);
    } else {
      displayProducts(allProducts);
    }
  });

  function displayProducts(products) {
    console.log("displayProducts", products)
    const resultsDiv = $(".collection ul#product-grid");
    console.log('displayProducts',  resultsDiv);
    resultsDiv.empty();

    if (products.length > 0) {
      products.forEach(function (product, index) {
        const imageSrc =
          product.images && product.images.length > 0
            ? product.images[0].src
            : ""; // Check if image exists
        const compareAtPrice = product.variants[0].compare_at_price
          ? `$${product.variants[0].compare_at_price} NZD`
          : "";

        const productHtml = `
          <li class="match-search grid__item scroll-trigger animate--slide-in" data-cascade="" style="--animation-order: ${
            index + 1
          };" data-val="${product.title}">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media" style="--ratio-percent: 57.8%;">
                <div class="card__inner ratio" style="--ratio-percent: 57.8%;">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      <img src="${imageSrc}" alt="${
          product.title
        }" class="motion-reduce" width="1000" height="578">
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading">
                        <a href="/products/${
                          product.handle
                        }" class="full-unstyled-link">${product.title}</a>
                      </h3>
                    </div>
                    <div class="card__badge bottom left"><span class="badge badge--bottom-left color-scheme-4">Sale</span></div>
                  </div>
                </div>
                <div class="card__content card_info_outer">
                  <div class="card__information">
                    <h3 class="card__heading h5 findrey">
                      <a href="/products/${
                        product.handle
                      }" class="full-unstyled-link">${product.title}</a>
                    </h3>
                    <div class="card-information flag-4">
                      <div class="price price--on-sale">
                        <div class="price__container">
                          <div class="price__regular">
                            <span class="visually-hidden">Regular price</span>
                            <span class="price-item price-item--regular">${compareAtPrice}</span>
                          </div>
                          <div class="price__sale">
                            <span class="visually-hidden">Sale price</span>
                            <span class="price-item price-item--sale price-item--last">$${
                              product.variants[0].price
                            } NZD</span>
                          </div>
                          <small class="unit-price caption hidden">
                            <span class="visually-hidden">Unit price</span>
                            <span class="price-item price-item--last"></span>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="add_to_cart_outer">
                      <div class="quick-add no-js-hidden">
                        <product-form data-section-id="template--14859619074145__product-grid">
                          <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                            <input type="hidden" name="form_type" value="product">
                            <input type="hidden" name="utf8" value="✓">
                            <input type="hidden" name="id" value="${
                              product.variants[0].id
                            }" class="product-variant-id">
                            <button type="submit" name="add" class="quick-add__submit btn button button--full-width button--secondary" aria-live="polite" data-sold-out-message="true">
                              <span>Add to cart</span>
                              <span class="sold-out-message hidden">Sold out</span>
                              <div class="loading__spinner hidden">
                                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                </svg>
                              </div>
                            </button>
                            <input type="hidden" name="product-id" value="${
                              product.id
                            }">
                            <input type="hidden" name="section-id" value="template--14859619074145__product-grid">
                          </form>
                        </product-form>
                      </div>
                    </div>
                    <div class="card__badge bottom left">
                      <span class="badge badge--bottom-left color-scheme-4">Sale</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>`;
        resultsDiv.append(productHtml);
      });
    } else {
      resultsDiv.append("<p>No products found.</p>");
    }
  }
});

$(document).on(
  "keyup keypress change",
  ".search_box_blog input, .filter_blog_contr select",
  function (e) {
    var q = $(".search_box_blog input").val().trim();
    var sortOrder = $(".filter_blog_contr select").val();
    var b = "&resources[type]=article";
    var url = "/search/suggest.json?q=" + (q === "" ? "a" : q) + b;
    $.ajax(url, {
      type: "GET",
      dataType: "json",
      success: function (response) {
        var articles =
          response.resources &&
          response.resources.results &&
          response.resources.results.articles
            ? response.resources.results.articles
            : [];
        var htmls = "";

        // Sorting
        switch (sortOrder) {
          case "created-descending":
            articles.sort(function (a, b) {
              return new Date(b.published_at) - new Date(a.published_at);
            });
            break;
          case "created-ascending":
            articles.sort(function (a, b) {
              return new Date(a.published_at) - new Date(b.published_at);
            });
            break;
          case "title-ascending":
            articles.sort(function (a, b) {
              return a.title.localeCompare(b.title, "en", {
                sensitivity: "base",
              });
            });
            break;
          case "title-descending":
            articles.sort(function (a, b) {
              return b.title.localeCompare(a.title, "en", {
                sensitivity: "base",
              });
            });
            break;
          default:
            break;
        }

        if (articles.length === 0) {
          htmls = "Not Found";
        } else {
          if (articles.length > 6) {
            articles = articles.slice(0, 6);
          }
          for (var i = 0; i < articles.length; i++) {
            var article = articles[i];
            var url = article.url;
            var title = article.title;
            var img = article.featured_image ? article.featured_image.url : "";
            htmls += `
                        <div class="blog-articles__article article scroll-trigger animate--slide-in" data-cascade="" style="--animation-order: 0;">
                            <div class="article-card-wrapper card-wrapper">
                                <div class="card_image">
                                    ${img ? `<img src="${img}" alt="">` : ""}
                                </div>
                                <div class="article_content">
                                    <div class="card_title">
                                        <h5 class="card__heading" style="color:#3e7351;">
                                            <a href="${url}" class="full-unstyled-link">
                                                ${title}
                                            </a>
                                        </h5>
                                    </div>
                                    <div class="card_excerpt"></div>
                                    <div class="author_and_date">
                                        <span class="circle-divider">
                                            <time datetime="${
                                              article.published_at ||
                                              "2024-08-01T09:21:23Z"
                                            }">
                                                ${
                                                  article.published_at
                                                    ? new Date(
                                                        article.published_at
                                                      ).toLocaleDateString()
                                                    : "August 1, 2024"
                                                }
                                            </time>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>`;
          }
        }
        $(".blog_posts_outer .blog-articles").html(htmls);
      },
    });
  }
);

document.addEventListener("DOMContentLoaded", function () {
  // Facebook Share Button
  const facebookButton = document.querySelector("button.facebook.btn");
  if (facebookButton) {
    facebookButton.addEventListener("click", function () {
      const urlToShare = window.location.href;
      const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        urlToShare
      )}`;
      window.open(
        facebookShareUrl,
        "facebook-share-dialog",
        "width=800,height=600"
      );
      return false;
    });
  } else {
    // console.log("Facebook Share button not found!");
  }

  // Twitter Share Button
  const twitterButton = document.querySelector("button.tweet.btn");
  if (twitterButton) {
    twitterButton.addEventListener("click", function () {
      const urlToShare = window.location.href;
      const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        urlToShare
      )}`;
      window.open(
        twitterShareUrl,
        "twitter-share-dialog",
        "width=800,height=600"
      );
      return false;
    });
  } else {
    // console.log("Twitter Share button not found!");
  }

  // LinkedIn Share Button
  const linkedinButton = document.querySelector("button.linkedin.btn");
  if (linkedinButton) {
    linkedinButton.addEventListener("click", function () {
      const urlToShare = window.location.href;
      const linkedinShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        urlToShare
      )}`;
      window.open(
        linkedinShareUrl,
        "linkedin-share-dialog",
        "width=800,height=600"
      );
      return false;
    });
  } else {
    // console.log("LinkedIn Share button not found!");
  }
});

function appendContent() {
  // return;
  let checkInterval;
  function checkAndAddFilter() {
      if ($(".gf-filter-contents").find("h2.filter-append").length === 0) {
          $(".gf-filter-contents").prepend(`<h2 class="filter-append">FILTER</h2>`);
      }
  }
  checkInterval = setInterval(checkAndAddFilter, 100);
  
  setTimeout(function () {
      if (
        $("div#gf_pagination_wrap div#pagination").find("span.prevv").length === 0
      ) {
        $("div#gf_pagination_wrap div#pagination").prepend(
          `<span class="prevv">Previous</span>`
        );
      }
      if (
        $("div#gf_pagination_wrap div#pagination").find("span.nextt").length === 0
      ) {
        $("div#gf_pagination_wrap div#pagination").append(
          `<span class="nextt">Next</span>`
        );
      }
      $(".for_only_append ul li.match-search").each(function () {
        var idd = $(this).attr("data-idd");
        var formsHtml = $(this).find(".add_to_cart_outer").html();
        var seatHtml = $(this).find(".card_seat_dimension").html();
        var priceHtml = $(this).find(".card-information").html();
  
        var $target = $("ul#gf-products h3#title-collection-template-" + idd);
        if ($target.find(".card_seat_dimension").length === 0 && seatHtml) {
          $target.prepend(`<div class="card_seat_dimension">${seatHtml}</div>`);
        }
        if ( $target.closest(".card__information").find(".add_to_cart_outer").length === 0 && formsHtml ) {
          $target.closest(".card__information").append(`<div class="add_to_cart_outer">${formsHtml}</div>`);
        }
        //overwrite price HTML format
        $target.closest(".card__information").find(".card-information").html(priceHtml);
        //console.log("priceHtml",  $target.find(".card-information"))
      });
  
      var productCount = document.querySelectorAll(
        ".collection ul#gf-products li"
      ).length;
      var activeProductsElement = document.querySelector(".active_products");
  
      if (activeProductsElement) {
        activeProductsElement.innerHTML = productCount;
      } else {
        //console.log("not found");
      }
      if (
        $("div#gf_pagination_wrap div#pagination span.page.current").next(
          "span.page"
        ).length === 0
      ) {
        $("#gf_pagination_wrap div#pagination span.nextt").addClass("disable");
      }
      if (
        $("div#gf_pagination_wrap div#pagination span.page.current").prev(
          "span.page"
        ).length === 0
      ) {
        $("#gf_pagination_wrap div#pagination span.prevv").addClass("disable");
      }
    }, 2000);
}

$(document).ready(function () {
  appendContent();
});

$(document).on(
  "click",
  ".gf-filter-contents button , div#globo-dropdown-sort_options span",
  function () {
    appendContent(); // Re-run on button click
    console.log("Button clicked, content updated");
  }
);
$(document).on(
  "input",
  ".product-grid-container div#gf-controls-container form.gf-controls-search-form input",
  function () {
    appendContent();
  }
);

$(document).on(
  "click",
  "div#gf_pagination_wrap div#pagination span.page",
  function (e) {
    e.preventDefault();
    e.stopPropagation();
    appendContent();
    // location.reload();
  }
);

$(document).on(
  "click",
  "#gf_pagination_wrap div#pagination span.prevv",
  function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#gf_pagination_wrap div#pagination span.page.current")
      .prev("span.page")
      .find("a")
      .click();
  }
);
$(document).on(
  "click",
  "#gf_pagination_wrap div#pagination span.nextt",
  function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#gf_pagination_wrap div#pagination span.page.current")
      .next("span.page")
      .find("a")
      .click();
  }
);

$(document).on('mouseenter', '.product_variant_picker .product-form__input--pill input[type=radio]+label', function() {
    $(this).find('.for_hover').css('opacity', '1');
});

$(document).on('mouseleave', '.product_variant_picker .product-form__input--pill input[type=radio]+label', function() {
    $(this).find('.for_hover').css('opacity', '0');
});

